import React from 'react';

import { OrdCreate, OrdEdit } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';

import { LcrsForm } from './LcrsForm';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { LcrRead } from '@ragu-components/ord-types';

export const LcrsCreate = (): React.ReactElement => (
  <OrdCreate>
    <LcrsForm />
  </OrdCreate>
);

export const LcrsEdit = (): React.ReactElement => (
  <OrdEdit>
    <LcrsForm />
  </OrdEdit>
);

const LcrsList = React.lazy(async () => import('./LcrsList'));

export const lcrsResources: OrdResourceProps = {
  key: Resources.lcrs,
  name: Resources.lcrs,
  list: <LcrsList />,
  edit: <LcrsEdit />,
  create: <LcrsCreate />,
  options: {},
  recordRepresentation: (record: LcrRead) => record.name,
};
